module.exports = __webpack_public_path__ + "img/logo-central.f14353d6.svg";